module.exports = require("core-js-pure/features/array/from");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/array/from.js
// module id = 2039
// module chunks = 25